<template>
  <div
    :class="wrapClass"
    class="wrap">
    <router-view name="header"/>
    <router-view name="content"/>
    <router-view name="footer"/>
  </div>
</template>

<script>

export default {
  name: 'DefaultLayout',
  computed: {
    wrapClass () {
      var wrapClass = {
      }
      if (this.$route.meta && this.$route.meta.wrapClass) {
        wrapClass[this.$route.meta.wrapClass] = true
      }

      if (this.$route.meta && this.$route.meta.hideFooter) {
        wrapClass['no-footer'] = true
      }

      return wrapClass
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/layouts/DefaultLayout.vue